import { render, staticRenderFns } from "./AdminAccountTagsInput.vue?vue&type=template&id=186f64f0&scoped=true&"
import script from "./AdminAccountTagsInput.vue?vue&type=script&lang=js&"
export * from "./AdminAccountTagsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186f64f0",
  null
  
)

export default component.exports